import Alpine from 'alpinejs';

type AlpineType = typeof Alpine;

export const SnapScroll = (Alpine: AlpineType) => {
    Alpine.directive('snap-scroll', (el: HTMLInputElement, directive, { cleanup, evaluate }) => {
        const handler = (event: WheelEvent) => {
            const { currentTarget, deltaY, deltaX } = event;
            if (deltaX == 0 && deltaY != 0 && currentTarget instanceof Element) {
                if (deltaY < 0 && currentTarget.scrollLeft <= 0) {
                    return;
                }
                if (deltaY > 0 && currentTarget.scrollLeft >= currentTarget.scrollWidth - currentTarget.clientWidth) {
                    return;
                }

                event.preventDefault();
                currentTarget.scrollLeft += deltaY * 10;
            }
        };

        el.addEventListener('mousewheel', handler);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        cleanup(() => {
            el.removeEventListener('mousewheel', handler);
        });
    });
};

export default SnapScroll;
